import { render } from "./FacebookPostReview.vue?vue&type=template&id=4c3427ad&scoped=true"
import script from "./FacebookPostReview.vue?vue&type=script&lang=js"
export * from "./FacebookPostReview.vue?vue&type=script&lang=js"

import "./FacebookPostReview.vue?vue&type=style&index=0&id=4c3427ad&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c3427ad"]])

export default __exports__